// extracted by mini-css-extract-plugin
export var animation_wrapper = "styles-module--animation_wrapper--h6XXF";
export var background = "styles-module--background--Kj-6X";
export var blink = "styles-module--blink--1NZfs";
export var content = "styles-module--content--85FJ0";
export var intro = "styles-module--intro--aebIX";
export var m_hero = "styles-module--m_hero--TCYD0";
export var overlay = "styles-module--overlay--ZAAlV";
export var wrapper = "styles-module--wrapper--WKpWV";